import {
  BOGGLE_BLUE_TILE_KIND,
  BOGGLE_GOLD_TILE_KIND,
  BOGGLE_PURPLE_TILE_KIND,
  type BoggleSpecialTileKind,
} from './kinds'
import type { BoggleSpecialTileDefinition } from './tileTypes'
import { blueTileDefinition } from './definitions/blue'
import { goldTileDefinition } from './definitions/gold'
import { purpleTileDefinition } from './definitions/purple'

export const BOGGLE_SPECIAL_TILE_REGISTRY: Record<
  BoggleSpecialTileKind,
  BoggleSpecialTileDefinition
> = {
  [BOGGLE_GOLD_TILE_KIND]: goldTileDefinition,
  [BOGGLE_BLUE_TILE_KIND]: blueTileDefinition,
  [BOGGLE_PURPLE_TILE_KIND]: purpleTileDefinition,
}
